import styled from 'styled-components';
import { compose } from 'utilities/functions/composition';
import { DescriptionDecorator } from 'components/common/form/decorators';

const Box = styled.div`
  display: flex;
  flex-direction: ${props => props.flexDirection};
  justify-content: ${props => props.justifyContent};
  align-items: ${props => props.alignItems};
  margin: ${props => props.margin};
  padding: ${props => props.padding};
  flex-wrap: ${props => props.flexWrap};
  flex-grow: ${props => props.flexGrow};
  flex: ${props => props.flex};
  align-self: ${props => props.alignSelf};
`;

export const DescriptionBox = compose(DescriptionDecorator)(Box);

export default Box;
